/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface BulkChannelToggleDto
 */
export interface BulkChannelToggleDto {
  _id?: string;
    /**
     * Channel to toggle: email, push, or inApp
     * @type {string}
     * @memberof BulkChannelToggleDto
     */
    channel: string;
    /**
     * Enable or disable this channel for all notification types
     * @type {boolean}
     * @memberof BulkChannelToggleDto
     */
    enabled: boolean;
    /**
     * Optional category filter to only toggle specific notification categories
     * @type {string}
     * @memberof BulkChannelToggleDto
     */
    category?: BulkChannelToggleDtoCategoryEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BulkChannelToggleDtoCategoryEnum {
    Transactional = 'transactional',
    Marketing = 'marketing',
    Security = 'security',
    Operational = 'operational',
    Financial = 'financial'
}

